import { clean } from "./clean";
import { PERSONABLE_NETID_COLLECTION, PERSONABLE_PROFILE_COLLECTION } from "./collections";
import { loadCurrentPerson, Name, Person } from "./person";
import { loadProfile, Profile } from "./profile";
export const loadCurrentName = async (db, netID) => {
  const person = await loadCurrentPerson(db, netID);
  if (!person) {
    return;
  }
  const profile = await loadProfile(db, netID);
  if (!profile) {
    return Name.check(person.name);
  } else {
    const first = profile.name || person.name.first;
    return Name.check({ last: person.name.last, first, full: `${first} ${person.name.last}` });
  }
};
export const loadCurrentNames = async (db, netIDs) => {
  const personByNetID = (await db.collection(PERSONABLE_NETID_COLLECTION).find({ netID: { $in: netIDs }, left: { $exists: false } }).toArray()).map((r) => Person.check(clean(r)));
  const profilesByNetID = new Map(
    (await db.collection(PERSONABLE_PROFILE_COLLECTION).find({ netID: { $in: Object.keys(personByNetID) }, invalidated: { $exists: false } }).toArray()).map((r) => Profile.check(clean(r))).map((p) => [p.netID, p])
  );
  return Object.fromEntries(
    new Map(
      personByNetID.map((person) => {
        const profile = profilesByNetID[person.netID];
        if (!profile) {
          return [person.netID, person.name];
        } else {
          const first = profile?.name ?? person.name.first;
          return [person.netID, Name.check({ last: person.name.last, first, full: `${first} ${person.name.last}` })];
        }
      })
    )
  );
};
//# sourceMappingURL=name.js.map
